import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import Link from '../base_link/component';
import { promotionClickGoogleTag } from '@utils/analytics';
import Icon from '../base_svg-icon/component';
import { Button } from 'audamatic-ui';

import './styles/styles.scss';
/**
 * GenreList component aka 'Genres & Rubrieken'
 * It shows the genres and categories
 */
class GenreList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      overflowing: false,
    };
    this.overflowRef = createRef();
  }

  componentDidMount() {
    let overflowing = false;
    if (this.categoryCount >= 6) {
      overflowing = true;
    } else {
      setTimeout(() => {
        const { clientHeight, scrollHeight } = this.overflowRef.current || {};
        overflowing = (scrollHeight > clientHeight);
      }, 400);
    }
    this.setState({
      overflowing,
    });
  }

  get categoryCount() {
    if (this.props.categories && this.props.categories.length) {
      return this.props.categories.length;
    }
    return 0;
  }


  toggleExpand = () => {
    this.setState((prevState) => {
      return {
        expanded: !prevState.expanded,
      };
    });
  };

  pushGoogleTags(cat) {
    this.props.store.pushToDataLayer(promotionClickGoogleTag(this.promotionTagFromCategory(cat)));
  }

  promotionTagFromCategory(cat) {
    return {
      title: 'Genre list',
      name: cat.name,
      backgroundImage: cat.url,
      variant: 'list',
      'component-type': 'genre',
    };
  }

  getList() {
    const { categories = [] } = this.props;
    const sortedCategories = categories.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });

    return (
      <ul>
        {sortedCategories.map((category, i) => (
          <li key={i}>
            <Link
              to={category.url}
              onClick={() => this.pushGoogleTags(category)}
            >
              {category.name}
            </Link>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    const { categories = [] } = this.props;
    const { expanded, overflowing } = this.state;
    const readMoreText = expanded ? 'Minder genres' : 'Meer genres';

    if (!categories.length) {
      return null;
    }

    return (
      <div className={`genre-list ${overflowing === true ? 'expandable' : ''} ${expanded ? 'open' : ''}`} data-test-id="component-genreList">
        <div className="container-ul" ref={this.overflowRef}>
          {this.getList()}
        </div>
        {!!overflowing && (
          <div className="toggle-button">
            <div className="readmore-toggle">
              <Button
                variant="link"
                size="large"
                iconLeft={<Icon name={`ico-arrow-circle-${expanded ? 'up' : 'down'}`} size={150} />}
                onClick={this.toggleExpand}
              >
                {readMoreText}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

// proptypes
GenreList.propTypes = {
  /**
   * The array of categories
   */
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  store: PropTypes.object,
};

export default GenreList;
